export const SAFARI_BROWSER = 'safari';
export const DEVICE_DESKTOP = 'desktop';
export const MacOS = 'Mac';
